import styled from "styled-components";
import { baseColors } from "../../../../themes/definitions/casino888/cis/base-colors";
import {HeaderNavbarMobileBaseDefaultBox} from "./header-navbar-mobile-base.default.box";

export const HeaderNavbarMobileBaseCisBox = styled(HeaderNavbarMobileBaseDefaultBox)`
    background-color: ${baseColors.black};
    color: #cccccc;
`;